"use client";
import BuyNowCart from "@/components/common/BuyNowCart";
import SignupForFree from "@/components/landingpage/SignupForFree";
import NewMainLayout from "@/components/layout/newMainLayout";
import Collection from "@/components/rarestproduct/Collection";
import FlavourWheel from "@/components/rarestproduct/FlavourWheel";
import ProductPortEllenFold from "@/components/rarestproduct/ProductPortEllenFold";
import SliderSection from "@/components/rarestproduct/SliderSection";
import TheCask from "@/components/rarestproduct/TheCask";
import TheCollection from "@/components/rarestproduct/TheCollection";
import TheOctaveProductDetails from "@/components/rarestproduct/TheOctaveProductDetails";
import TheTestingNotes from "@/components/rarestproduct/TheTestingNotes";
import ScoMeta from "@/components/scometa";
import { getCheckoutLineItems } from "@/util/utils";
import { useAppCommonStore } from "@/zustand/appCommon";
import React, { useEffect, useState } from "react";
import { formatImageUrl } from "../../../helper/helper";
import DetailsSection from "@/components/new-product-details/DescriptionSection";
import DescriptionSection from "@/components/new-product-details/DescriptionSection";
import NewProductDetailsSection from "@/components/new-product-details/NewProductDetailsSection";
import NewProductDetailsCollection from "@/components/new-product-details/NewProductDetailsCollection";
import ProductDetailsFirstFold from "@/components/new-product-details/ProductDetailsFirstFold";

const NewProductDetails = (props: any) => {
  const { data, meta } = props;
  const {
    checkout,
    setCheckout,
    selectedCountry,
    updateQuantityInCart,
    removeLineItemInCart,
    openModal,
    toggleCartSidebar,
  } = useAppCommonStore((state: any) => ({
    checkout: state.checkout,
    setCheckout: state.setCheckout,
    selectedCountry: state.selectedCountry,
    updateQuantityInCart: state.updateQuantityInCart,
    removeLineItemInCart: state.removeLineItemInCart,
    openModal: state.openModal,
    toggleCartSidebar: state.toggleCartSidebar,
  }));

  const [productDetailsData, setproductDetailsData]: any = useState([]);

  useEffect(() => {
    getCheckoutLineItems(selectedCountry.value).then((res) => {
      setCheckout({
        ...res,
      });
    });
  }, []);

  useEffect(() => {
    if (data) {
      setproductDetailsData(data?.data?.attributes);
    }
  }, [data]);

  const renderNewProductDetailsPage = () => {
    return (
      <>
        {productDetailsData?.blocks && productDetailsData?.blocks.length
          ? productDetailsData?.blocks.map((content: any, index: any) => {
              switch (content.__component) {
                case "product.info-section":
                  return (
                    <div
                      id="details"
                      className="new-product-description-section"
                    >
                      <DescriptionSection
                        key={content?.id + index}
                        data={content}
                      />
                    </div>
                  );

                case "product.product-detail":
                  return (
                    <NewProductDetailsSection
                      key={content?.id + index}
                      data={content}
                    />
                  );

                case "product.discover-more":
                  return (
                    <NewProductDetailsCollection
                      key={content?.id + index}
                      data={content}
                      countryCode={selectedCountry.value}
                    />
                  );

                default:
                  return null;
              }
            })
          : null}
      </>
    );
  };
  let bgImage: any;

  if (typeof window !== "undefined") {
    bgImage = formatImageUrl(
      window.innerWidth <= 760
        ? "https://blackbullwebsitestaging.s3.ap-south-1.amazonaws.com/Group_1410103871_6d0155a029.png"
        : "https://blackbullwebsitestaging.s3.ap-south-1.amazonaws.com/Group_1410103870_c61961aac7.png"
    );
  }

  return (
    <section
      className="new-product-details-section"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <BuyNowCart
        countryCode={selectedCountry.value}
        openModal={openModal}
        toggleCartSidebar={toggleCartSidebar}
        checkout={checkout}
        updateQuantityInCart={updateQuantityInCart}
        removeLineItemInCart={removeLineItemInCart}
      />
      <head>
        <ScoMeta meta={meta ? meta : {}} />
      </head>
      {productDetailsData && (
        <NewMainLayout
          checkout={checkout}
          toggleCartSidebar={toggleCartSidebar}
        >
          <>
            <ProductDetailsFirstFold
              data={productDetailsData}
              countryCode={selectedCountry.value}
              checkout={checkout}
              setCheckout={setCheckout}
            />
            {productDetailsData && renderNewProductDetailsPage()}

            <SignupForFree />
          </>
        </NewMainLayout>
      )}
    </section>
  );
};

export default NewProductDetails;
